import { render, staticRenderFns } from "./cardInternationalProductExtral.vue?vue&type=template&id=2fdf2c9e&scoped=true&"
import script from "./cardInternationalProductExtral.vue?vue&type=script&lang=js&"
export * from "./cardInternationalProductExtral.vue?vue&type=script&lang=js&"
import style0 from "./cardInternationalProductExtral.vue?vue&type=style&index=0&id=2fdf2c9e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf2c9e",
  null
  
)

export default component.exports